var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.showFaqTitle && _vm.userInputChoices.length >= 1) ||
    (_vm.showFaqTitle && _vm.inputMessage)
    ? _c("div", { staticClass: "saichat-suggestion" }, [
        _vm.showFaqTitle
          ? _c("div", { staticClass: "saichat-suggestion__header" }, [
              _vm.isYokuaru
                ? _c(
                    "div",
                    { staticClass: "saichat-suggestion__header__title" },
                    [_vm._v(_vm._s(_vm.constObj.YOKUARU_TITLE))]
                  )
                : _c(
                    "div",
                    { staticClass: "saichat-suggestion__header__title" },
                    [_vm._v(_vm._s(_vm.constObj.CHOICES_TITLE))]
                  ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "saichat-suggestion__header__closeArea" },
                [
                  _c(
                    "svg",
                    {
                      class: "saichat-suggestion__header__closeIcon",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 111.53 111.53",
                        "svg-inline": "",
                        role: "presentation",
                        focusable: "false",
                        tabindex: "-1"
                      },
                      on: { click: _vm.close }
                    },
                    [
                      _c("path", {
                        staticClass: "b",
                        attrs: {
                          d: "M5.66 105.88L105.88 5.66M5.66 5.66l100.22 100.22"
                        }
                      })
                    ]
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "saichat-suggestion__content" }, [
          _c(
            "ul",
            { staticClass: "saichat-suggestion__choiceList" },
            [
              _vm._l(_vm.userInputChoices, function(choice, i) {
                return _c(
                  "li",
                  {
                    key: i,
                    staticClass: "saichat-suggestion__choiceList__choice"
                  },
                  [
                    choice
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.selectAnswer(choice, i)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "saichat-suggestion__choiceList__ancester"
                              },
                              _vm._l(choice.ancesters, function(
                                ancester,
                                index
                              ) {
                                return _c("span", { key: index }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(ancester.text) +
                                      "\n              "
                                  ),
                                  index < choice.ancesters.length - 1
                                    ? _c("span", [_vm._v("/")])
                                    : _vm._e()
                                ])
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "saichat-suggestion__choiceList__text",
                              domProps: {
                                innerHTML: _vm._s(
                                  choice.displayText || choice.text
                                )
                              }
                            })
                          ]
                        )
                      : _vm._e()
                  ]
                )
              }),
              _vm._v(" "),
              !_vm.isYokuaru &&
              _vm.userInputChoices.length &&
              _vm.constObj.HAS_UNRESOLVED_ENQUETE
                ? _c(
                    "a",
                    {
                      staticClass:
                        "saichat-suggestion__choiceList__searchFailed",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.openEnquete(_vm.searchFailed)
                        }
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          class: "saichat-suggestion__enqueteIcon",
                          staticStyle: { width: "15px", height: "15px" },
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 512 512",
                            "svg-inline": "",
                            role: "presentation",
                            focusable: "false",
                            tabindex: "-1"
                          }
                        },
                        [
                          _c("path", {
                            staticClass: "st0",
                            attrs: {
                              d:
                                "M155.907 110.129h129.006c15.28 0 27.653-12.382 27.653-27.662V54.767c0-15.28-12.373-27.662-27.653-27.662h-34.96C248.555 11.929 235.944 0 220.41 0c-15.55 0-28.162 11.929-29.56 27.105h-34.943c-15.281 0-27.67 12.382-27.67 27.662v27.701c0 15.28 12.389 27.661 27.67 27.661zm64.503-93.864c7.481 0 13.549 6.068 13.549 13.548 0 7.489-6.068 13.557-13.549 13.557-7.497 0-13.565-6.068-13.565-13.557 0-7.481 6.067-13.548 13.565-13.548zM480.09 160.996c.08.072.128.159.191.238.063.055.143.095.19.15l-.381-.388zM480.282 161.235c-8.927-8.752-23.254-8.72-32.116.15l-20.331 20.331 31.926 31.926 20.331-20.331c8.846-8.855 8.894-23.15.19-32.076zM280.878 401.966l69.285-69.276-41.377-41.377-69.284 69.292c-4.146 4.153-4.146 10.904 0 15.065l26.303 26.295c4.161 4.163 10.912 4.163 15.073.001zM218.122 417.81l-9.593 9.61 5.527 5.536 9.61-9.602 41.186-13.486-33.245-33.236zM383.058 100.782v93.276l32.53-32.53v-58.84c0-25.462-20.649-46.103-46.11-46.103h-40.647v25.882c0 3.113-.333 6.155-.953 9.094h45.951c5.099 0 9.229 4.13 9.229 9.221z"
                            }
                          }),
                          _c("path", {
                            staticClass: "st0",
                            attrs: {
                              d:
                                "M383.058 457.241c0 5.091-4.13 9.22-9.229 9.22H66.974c-5.083 0-9.212-4.13-9.212-9.22v-356.46c0-5.091 4.13-9.22 9.212-9.22h45.968a44.017 44.017 0 01-.969-9.094V56.585H71.326c-25.462 0-46.094 20.641-46.094 46.103v363.21c0 25.461 20.633 46.102 46.094 46.102h298.151c25.461 0 46.11-20.641 46.11-46.102V290.257l-32.53 32.53v134.454z"
                            }
                          }),
                          _c("path", {
                            staticClass: "st0",
                            attrs: {
                              d:
                                "M316.172 283.928l41.377 41.369 100.94-100.948-41.361-41.361-100.956 100.94zm110.804-69.436c3.574 3.566 3.574 9.364 0 12.929l-49.112 49.12a9.15 9.15 0 01-12.929 0c-3.574-3.566-3.574-9.364 0-12.93l49.128-49.12c3.557-3.565 9.355-3.565 12.913.001zM93.086 182.454l32.658 32.673 11.88-11.88 32.673-32.673-11.881-11.873-32.672 32.665-20.776-20.792zM158.416 244.091l-32.672 32.665-20.776-20.792-11.882 11.881 32.658 32.673 11.88-11.881 32.673-32.673zM104.968 341.354l-11.882 11.881 32.658 32.673 11.88-11.881 32.673-32.673-11.881-11.873-32.672 32.665z"
                            }
                          })
                        ]
                      ),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.constObj.OTHER_CHOICE_LINK_MESSAGE) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          !_vm.userInputChoices.length && !_vm.isEntering
            ? _c(
                "div",
                { staticClass: "saichat-suggestion__scriptNotFound" },
                [
                  _vm.constObj.SHOW_SUGGESTION_SCRIPT_NOT_FOUND_ICON
                    ? _c("font-awesome-icon", {
                        staticClass: "saichat-suggestion__scriptNotFound__icon",
                        attrs: { icon: ["far", "face-sad-tear"] }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "saichat-suggestion__scriptNotFound__text" },
                    [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.constObj.SCRIPT_NOT_FOUND_RESULTS_MESSAGE
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm.constObj.HAS_UNRESOLVED_ENQUETE
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "saichat-suggestion__scriptNotFound__link",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.openEnquete(_vm.searchNoScript)
                                }
                              }
                            },
                            [
                              _c(
                                "svg",
                                {
                                  class: "saichat-suggestion__enqueteIcon",
                                  staticStyle: {
                                    width: "15px",
                                    height: "15px"
                                  },
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 512 512",
                                    "svg-inline": "",
                                    role: "presentation",
                                    focusable: "false",
                                    tabindex: "-1"
                                  }
                                },
                                [
                                  _c("path", {
                                    staticClass: "st0",
                                    attrs: {
                                      d:
                                        "M155.907 110.129h129.006c15.28 0 27.653-12.382 27.653-27.662V54.767c0-15.28-12.373-27.662-27.653-27.662h-34.96C248.555 11.929 235.944 0 220.41 0c-15.55 0-28.162 11.929-29.56 27.105h-34.943c-15.281 0-27.67 12.382-27.67 27.662v27.701c0 15.28 12.389 27.661 27.67 27.661zm64.503-93.864c7.481 0 13.549 6.068 13.549 13.548 0 7.489-6.068 13.557-13.549 13.557-7.497 0-13.565-6.068-13.565-13.557 0-7.481 6.067-13.548 13.565-13.548zM480.09 160.996c.08.072.128.159.191.238.063.055.143.095.19.15l-.381-.388zM480.282 161.235c-8.927-8.752-23.254-8.72-32.116.15l-20.331 20.331 31.926 31.926 20.331-20.331c8.846-8.855 8.894-23.15.19-32.076zM280.878 401.966l69.285-69.276-41.377-41.377-69.284 69.292c-4.146 4.153-4.146 10.904 0 15.065l26.303 26.295c4.161 4.163 10.912 4.163 15.073.001zM218.122 417.81l-9.593 9.61 5.527 5.536 9.61-9.602 41.186-13.486-33.245-33.236zM383.058 100.782v93.276l32.53-32.53v-58.84c0-25.462-20.649-46.103-46.11-46.103h-40.647v25.882c0 3.113-.333 6.155-.953 9.094h45.951c5.099 0 9.229 4.13 9.229 9.221z"
                                    }
                                  }),
                                  _c("path", {
                                    staticClass: "st0",
                                    attrs: {
                                      d:
                                        "M383.058 457.241c0 5.091-4.13 9.22-9.229 9.22H66.974c-5.083 0-9.212-4.13-9.212-9.22v-356.46c0-5.091 4.13-9.22 9.212-9.22h45.968a44.017 44.017 0 01-.969-9.094V56.585H71.326c-25.462 0-46.094 20.641-46.094 46.103v363.21c0 25.461 20.633 46.102 46.094 46.102h298.151c25.461 0 46.11-20.641 46.11-46.102V290.257l-32.53 32.53v134.454z"
                                    }
                                  }),
                                  _c("path", {
                                    staticClass: "st0",
                                    attrs: {
                                      d:
                                        "M316.172 283.928l41.377 41.369 100.94-100.948-41.361-41.361-100.956 100.94zm110.804-69.436c3.574 3.566 3.574 9.364 0 12.929l-49.112 49.12a9.15 9.15 0 01-12.929 0c-3.574-3.566-3.574-9.364 0-12.93l49.128-49.12c3.557-3.565 9.355-3.565 12.913.001zM93.086 182.454l32.658 32.673 11.88-11.88 32.673-32.673-11.881-11.873-32.672 32.665-20.776-20.792zM158.416 244.091l-32.672 32.665-20.776-20.792-11.882 11.881 32.658 32.673 11.88-11.881 32.673-32.673zM104.968 341.354l-11.882 11.881 32.658 32.673 11.88-11.881 32.673-32.673-11.881-11.873-32.672 32.665z"
                                    }
                                  })
                                ]
                              ),
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.constObj
                                      .SCRIPT_NOT_FOUND_RESULTS_LINK_MESSAGE
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }